<template>
  <div>
    <div class="text-xs-right">
      <v-btn depressed color="primary" @click="handleAddPromotionItem">
        <span>Add</span>
      </v-btn>
    </div>
    <div class="pt-4">
      <template v-if="promotionItems && promotionItems.length > 0">
        <template v-for="(item, index) in promotionItems">
          <div class="pa-3 mb-3" style="border: 1px solid #ccc; border-radius: 4px" :key="index">
            <v-layout wrap>
              <template v-if="promotionType === 'ซื้อสินค้าครบ'">
                <v-flex xs3>
                  <div class="primary--text">{{ getItemCategory(item.type) }}</div>
                  <div>{{ getItemName(item) }}</div>
                </v-flex>
                <v-flex xs3>
                  <div class="primary--text">
                    {{ item.price_type === 'item' ? 'ซื้อครบจำนวนชิ้น' : 'ซื้อมูลค่าตั้งแต่' }}
                  </div>
                  <div>{{ item.price_from }}</div>
                </v-flex>
              </template>
              <template v-else>
                <v-flex xs3>
                  <div class="primary--text">{{ getItemCategory(item.type_1) }}</div>
                  <div>{{ getItemName(item, 'type_1') }}</div>
                </v-flex>
                <v-flex xs3>
                  <div class="primary--text">{{ getItemCategory(item.type_2) }}</div>
                  <div>{{ getItemName(item, 'type_2') }}</div>
                </v-flex>
              </template>

              <v-flex xs3>
                <div class="primary--text">
                  {{ item.increased_type === 'multiply' ? 'คูณคะแนน' : 'รับคะแนนเพิ่ม' }}
                </div>
                <div>{{ item.increased }}</div>
              </v-flex>

              <v-flex xs3 class="text-xs-right">
                <v-btn
                  fab
                  small
                  color="warning"
                  outline
                  class="mx-1 my-0"
                  @click="handleEditPromotionItem(item)"
                  ><v-icon>edit</v-icon></v-btn
                >
                <v-btn
                  fab
                  small
                  color="error"
                  outline
                  class="mx-1 my-0"
                  @click="handleDeletePromotionItem(item.id)"
                  ><v-icon>delete</v-icon></v-btn
                >
              </v-flex>
            </v-layout>
          </div>
        </template>
        <!-- <div class="mt-2">
          <v-pagination
            :total-visible="6"
            v-model="pageNumber"
            @input="handleChangePage"
            :length="pagelength"
          ></v-pagination>
        </div> -->
      </template>
      <div v-else class="text-xs-center grey lighten-3 py-3" style="border-radius: 10px">
        No data available
      </div>
    </div>

    <v-dialog v-model="showManageItemDialog" persistent width="600px">
      <PromotionItemsManage
        v-if="showManageItemDialog"
        v-model="selectedItem"
        :promotionType="promotionType"
        :promotionId="promotionId"
        :formType="formType"
        @success="handleSuccessManage"
        @close="handleCloseManage"
      ></PromotionItemsManage>
    </v-dialog>
  </div>
</template>

<script>
import toaCrmApi from '@/api/toa-crm'
import PromotionItemsManage from './PromotionItemsManage'
import { mapGetters } from 'vuex'

export default {
  props: ['promotionId'],
  components: {
    PromotionItemsManage
  },
  data() {
    return {
      showManageItemDialog: false,
      promotionType: null,
      formType: 'add',
      promotionItems: [],
      selectedItem: null
    }
  },
  mounted() {
    if (this.promotionId) {
      this.handleGetPromotionItems()
    }

    this.handleGetMasterData()
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  methods: {
    async handleGetPromotionItems() {
      const vm = this
      try {
        vm.$store.dispatch('loading')
        const response = await toaCrmApi.getPromotionById({
          pageId: vm.selectedBot.pageid,
          id: vm.promotionId
        })
        vm.$store.dispatch('loading')

        if (response && response.status === 200) {
          vm.promotionType = response.data.data[0].promotion_type
          vm.promotionItems = response.data.data[0].cordition
        }
      } catch (error) {
        console.error(error)
      }
    },
    getItemCategory(type) {
      if (type === 'product') {
        return 'สินค้า'
      } else if (type === 'mkt') {
        return 'Marketing'
      } else {
        return 'Sub Marketing'
      }
    },
    getItemName(item, column = null) {
      let name = ''
      if (item) {
        if (this.promotionType === 'ซื้อสินค้าครบ') {
          switch (item.type) {
            case 'product':
              name = item.product_id
              break
            case 'mkt':
              name = item.mkt_id
              break
            case 'submkt':
              name = item.sub_mkt_id
              break

            default:
              break
          }
        } else {
          const type = column === 'type_1' ? item.type_1 : item.type_2
          switch (type) {
            case 'product':
              name = column === 'type_1' ? item.product_id_1 : item.product_id_2
              break
            case 'mkt':
              name = column === 'type_1' ? item.mkt_id_1 : item.mkt_id_2
              break
            case 'submkt':
              name = column === 'type_1' ? item.sub_mkt_id_1 : item.sub_mkt_id_2
              break

            default:
              break
          }
        }
      }

      return name
    },
    handleAddPromotionItem() {
      this.formType = 'add'
      this.showManageItemDialog = true
    },
    handleEditPromotionItem(item) {
      this.selectedItem = item
      this.formType = 'edit'
      this.showManageItemDialog = true
    },
    async handleDeletePromotionItem(id) {
      const vm = this
      try {
        const result = await vm.$swal.fire({
          type: 'warning',
          text: 'คุณต้องการลบใช่หรือไม่',
          showCancelButton: true,
          cancelButtonText: vm.$t('cancel'),
          confirmButtonText: vm.$t('OK'),
          reverseButtons: true
        })

        if (result.value) {
          vm.$store.dispatch('loading')
          const response = await vm.deletePromotionItem(id)
          vm.$store.dispatch('loading')

          if (response && response.status === 200) {
            await this.$swal.fire({
              text: 'สำเร็จ',
              type: 'success'
            })
            vm.handleGetPromotionItems()
          }
        }
      } catch (error) {
        console.error(error)
      }
    },
    async deletePromotionItem(id) {
      const vm = this
      try {
        let response = null
        if (vm.promotionType === 'ซื้อสินค้าครบ') {
          response = await toaCrmApi.deletePromotionFullPurchaseDetail({
            pageId: vm.selectedBot.pageid,
            id: id
          })
        } else {
          response = await toaCrmApi.deletePromotionMatchDetail({
            pageId: vm.selectedBot.pageid,
            id: id
          })
        }
        if (response) {
          return response
        } else {
          return null
        }
      } catch (error) {
        console.error(error)
        return null
      }
    },
    handleSuccessManage() {
      this.handleGetPromotionItems()
      this.selectedItem = null
      this.showManageItemDialog = false
    },
    handleCloseManage() {
      this.selectedItem = null
      this.showManageItemDialog = false
    },
    async handleGetMasterData() {
      const vm = this
      try {
        vm.getMasterdataProductNameList()
        vm.getMasterDataProductMarketingList()
        vm.getMasterDataProductSubMarketingList()
      } catch (error) {
        console.error(error)
      }
    },
    async getMasterDataProductMarketingList() {
      const vm = this
      try {
        const response = await toaCrmApi.getProductMarketingList({ pageId: vm.selectedBot.pageid })

        if (response && response.status === 200) {
          vm.$store.state.toacrmProductMarketing = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getMasterDataProductSubMarketingList() {
      const vm = this
      try {
        const response = await toaCrmApi.getProductSubMarketingList({
          pageId: vm.selectedBot.pageid
        })

        if (response && response.status === 200) {
          vm.$store.state.toacrmProductSubMarketing = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    },
    async getMasterdataProductNameList() {
      const vm = this
      try {
        const response = await toaCrmApi.getProductNameList({ pageId: vm.selectedBot.pageid })
        if (response && response.status === 200) {
          vm.$store.state.toacrmProductName = response.data.data
        }
      } catch (error) {
        console.error(error)
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toacrm/Promotion/PromotionItems.vue